/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react'
import { Form, Input, Icon, Popup } from 'semantic-ui-react'

export default class MarkUpPercentageField extends PureComponent {
  render() {
    const { value, onChange } = this.props

    return (
      <Form.Field required>
        <label>
          Mark Up Percentage
          <Popup
            content="remaining vat will be included to mark up fee"
            trigger={<Icon name="circle info" />}
          />
        </label>
        <Input
          label={{ content: '%' }}
          labelPosition="right"
          placeholder="e.g 10"
          type="number"
          min="0"
          required
          onChange={e => onChange('mark_up_percentage', e.target.value)}
          value={value}
        />
      </Form.Field>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/markUpPercentageField.js